import React from "react";
import { Box, Typography, MenuItem, Select, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPanel,
  addInverter,
} from "../../../store/slices/pva_testReport.slices";
import { inverters, panels } from "../../data/staticData";
import InverterAccordion from "./pva_component/invAcc";
import { updateFormField } from "../../../store/slices/inspection_info.slices";
import CustomInputLabel from "../../../component/customInputLabel/customInputLabel";

const PVATestReport = ({ errors = {} }) => {
  const dispatch = useDispatch();
  const { selectedPanel, invertersList } = useSelector(
    (state) => state.pva_test
  );
  const { formData } = useSelector((state) => state.ins_info);

  const handleChange = (e) => {
    dispatch(updateFormField({ field: e.target.name, value: e.target.value }));
  };

  return (
    <Box sx={{ padding: 2, maxWidth: 530, margin: "0 auto" }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Solar PV Array Test
      </Typography>

      {/* 🔹 Dropdown Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          mb: 3,
          width: "100%",
        }}
      >
        {/* Panel Selection */}
        <CustomInputLabel title="Select Panel"></CustomInputLabel>
        <Select
          size="small"
          value={selectedPanel ?? ""}
          onChange={(e) => {
            const selectedName = e.target.value;
            const panelData =
              panels.find((p) => p.name === selectedName) || null;
            dispatch(selectPanel(panelData));
          }}
          displayEmpty
          sx={{ width: "100%" }}
        >
          <MenuItem value="">Select Panel</MenuItem>

          {panels.map((panel) => (
            <MenuItem key={panel.name} value={panel.name}>
              {panel.name}
            </MenuItem>
          ))}
        </Select>
        {errors.selectedPanel && !selectedPanel && (
          <span className="error">Panel Selection Required</span>
        )}

        {/* Inverter Selection */}
        <CustomInputLabel
          title="Select Inverter"
          isRequired={false}
        ></CustomInputLabel>
        <Select
          displayEmpty
          size="small"
          defaultValue=""
          onChange={(e) => {
            const selected = inverters.find(
              (inv) => inv.name === e.target.value
            );
            if (selected) {
              dispatch(
                addInverter({
                  name: selected.name,
                  noOfMppt: selected.noOfMPPT,
                  noOfStrings: selected.noOfStrings,
                })
              );
            }
          }}
          sx={{ width: "100%" }}
        >
          <MenuItem value="">Add Inverter</MenuItem>
          {inverters.map((inv) => (
            <MenuItem key={inv.name} value={inv.name}>
              {inv.name}
            </MenuItem>
          ))}
        </Select>
        {errors.inverter && invertersList.length <= 0 && (
          <span className="error">
            Inverter selection required for PV Array Test Report
          </span>
        )}
      </Box>

      {/* 🔸 Render InverterAccordion for each inverter */}
      {invertersList.map((inverter, inverterIndex) => (
        <InverterAccordion
          key={inverterIndex}
          inverter={inverter}
          inverterIndex={inverterIndex}
          errors={errors}
        />
      ))}

      <TextField
        fullWidth
        label="Comment for PV String Test Doc"
        name="pvStringComment"
        multiline
        rows={3}
        inputProps={{ maxLength: 500 }}
        value={formData?.pvStringComment}
        onChange={handleChange}
        className="form-field"
        helperText={`${formData.pvStringComment.length}/500 characters`}
        sx={{ maxWidth: "500px", mt: 2 }}
      />
    </Box>
  );
};

export default PVATestReport;
